/* ManMade Cycle — landing page interactions
   Vanilla port of the design project's React behaviors. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('.mmc-landing');
    if (!root) return;

    /* ---------- Scroll reveals ---------- */
    var revealEls = document.querySelectorAll('.reveal, .hero-title');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });

    /* ---------- Nav: dark over hero, light bar once scrolled past ---------- */
    var nav = document.getElementById('mmc-nav');
    var hero = document.querySelector('.hero');
    if (nav && hero) {
      var onNavScroll = function () {
        // Hero is sticky, so use scroll distance past it rather than an
        // IntersectionObserver (which never fires for a pinned element).
        var past = window.scrollY > hero.offsetHeight * 0.6;
        nav.classList.toggle('is-light', past);
        nav.classList.toggle('is-dark', !past);
        nav.classList.toggle('glass', past);
      };
      onNavScroll();
      window.addEventListener('scroll', onNavScroll, { passive: true });
    }

    /* ---------- Nav: mobile burger + slide-down menu ---------- */
    var burger = document.getElementById('mmc-burger');
    var mobileMenu = document.getElementById('mmc-mobile-menu');
    if (nav && burger && mobileMenu) {
      var setMenu = function (open) {
        nav.classList.toggle('menu-open', open);
        mobileMenu.classList.toggle('open', open);
        mobileMenu.setAttribute('aria-hidden', String(!open));
        burger.setAttribute('aria-expanded', String(open));
        burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        // Lock page scroll while the mobile menu is open
        document.documentElement.style.overflow = open ? 'hidden' : '';
      };
      burger.addEventListener('click', function () {
        setMenu(!nav.classList.contains('menu-open'));
      });
      mobileMenu.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { setMenu(false); });
      });
      var brandLink = nav.querySelector('.brand');
      if (brandLink) brandLink.addEventListener('click', function () { setMenu(false); });
    }

    /* ---------- Hero: scroll-driven shrink + fade of the pinned hero ---------- */
    var heroContent = document.getElementById('mmc-hero-content');
    if (hero && heroContent) {
      var raf = 0;
      var update = function () {
        var range = hero.offsetHeight || window.innerHeight;
        var progress = Math.min(1, Math.max(0, window.scrollY / range));
        var scale = 1 - progress * 0.28;
        var opacity = Math.max(0, 1 - progress * 1.4);
        var translateY = -progress * 28;
        var blur = progress * 14;
        heroContent.style.transform = 'translateY(' + translateY + 'px) scale(' + scale + ')';
        heroContent.style.opacity = opacity;
        heroContent.style.filter = 'blur(' + blur + 'px)';
        hero.style.opacity = Math.max(0, 1 - progress * 1.6);
      };
      var onHeroScroll = function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; update(); });
      };
      update();
      window.addEventListener('scroll', onHeroScroll, { passive: true });
    }

    /* ---------- Hero: custom cursor ---------- */
    var cursor = document.getElementById('mmc-cursor');
    var cursorDot = document.getElementById('mmc-cursor-dot');
    if (hero && cursor && cursorDot) {
      var target = { x: -100, y: -100 };
      var curr = { x: -100, y: -100 };
      hero.addEventListener('mousemove', function (e) {
        target = { x: e.clientX, y: e.clientY };
        cursorDot.style.left = target.x + 'px';
        cursorDot.style.top = target.y + 'px';
      });
      (function loop() {
        curr.x += (target.x - curr.x) * 0.18;
        curr.y += (target.y - curr.y) * 0.18;
        cursor.style.left = curr.x + 'px';
        cursor.style.top = curr.y + 'px';
        requestAnimationFrame(loop);
      })();
      hero.addEventListener('mouseenter', function () {
        cursor.style.opacity = 1; cursorDot.style.opacity = 1;
      });
      hero.addEventListener('mouseleave', function () {
        cursor.style.opacity = 0; cursorDot.style.opacity = 0;
      });
    }

    /* ---------- Hero: image trail ---------- */
    var stage = document.getElementById('mmc-trail');
    var dataEl = document.getElementById('mmc-trail-data');
    if (hero && stage && dataEl) {
      var photos = JSON.parse(dataEl.textContent);
      var TILE_SIZE = 260;
      var MIN_DIST = 130;
      var LIFETIME = 2400;
      var items = [];
      var last = { x: 0, y: 0, t: 0, idx: 0 };
      var idCounter = 0;

      // Matches the design: newer tiles crisp, older tiles blur and fade.
      var restyle = function () {
        var now = performance.now();
        items.forEach(function (it, idx) {
          var fromEnd = items.length - 1 - idx;
          var lifeT = (now - it.born) / LIFETIME;
          var blur = Math.min(20, fromEnd * 2.4 + lifeT * 8);
          var opacity = Math.max(0, 1 - fromEnd * 0.10 - lifeT * 0.5);
          var scale = 1 - fromEnd * 0.018;
          it.el.style.transform = 'rotate(' + it.rotation + 'deg) scale(' + scale + ')';
          it.el.style.opacity = opacity;
          it.el.style.filter = 'blur(' + blur + 'px) drop-shadow(0 30px 60px rgba(0,0,0,0.45))';
        });
      };

      hero.addEventListener('mousemove', function (e) {
        var rect = stage.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        if (x < 0 || y < 0 || x > rect.width || y > rect.height) return;

        var dx = x - last.x;
        var dy = y - last.y;
        if (Math.sqrt(dx * dx + dy * dy) < MIN_DIST && last.t !== 0) return;

        var idx = last.idx % photos.length;
        var id = ++idCounter;
        var rotation = (Math.random() - 0.5) * 14;
        var size = TILE_SIZE * (0.92 + Math.random() * 0.20);

        var el = document.createElement('div');
        el.className = 'trail-img';
        el.style.left = (x - size / 2) + 'px';
        el.style.top = (y - size / 2) + 'px';
        el.style.width = size + 'px';
        el.style.height = size + 'px';
        el.style.zIndex = id;
        el.style.transition = 'opacity 1200ms cubic-bezier(.2,.7,.2,1), filter 1200ms cubic-bezier(.2,.7,.2,1), transform 1200ms cubic-bezier(.2,.7,.2,1)';
        var img = document.createElement('img');
        img.src = photos[idx];
        img.alt = '';
        img.draggable = false;
        el.appendChild(img);
        stage.appendChild(el);

        var item = { id: id, el: el, rotation: rotation, born: performance.now() };
        items.push(item);
        while (items.length > 12) {
          var gone = items.shift();
          gone.el.remove();
        }
        restyle();

        last = { x: x, y: y, t: performance.now(), idx: last.idx + 1 };

        setTimeout(function () {
          var i = items.indexOf(item);
          if (i !== -1) items.splice(i, 1);
          item.el.remove();
          restyle();
        }, LIFETIME);
      });

      hero.addEventListener('mouseleave', function () {
        last = { x: 0, y: 0, t: 0, idx: last.idx };
      });
    }

    /* ---------- Countdown to end of 2026 ---------- */
    var cd = {
      d: document.getElementById('mmc-cd-d'),
      h: document.getElementById('mmc-cd-h'),
      m: document.getElementById('mmc-cd-m'),
      s: document.getElementById('mmc-cd-s')
    };
    if (cd.d && cd.h && cd.m && cd.s) {
      var targetTs = new Date(2026, 11, 31, 23, 59, 59).getTime();
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var tick = function () {
        var diff = Math.max(0, targetTs - Date.now());
        cd.d.textContent = pad(Math.floor(diff / 86400000));
        cd.h.textContent = pad(Math.floor(diff % 86400000 / 3600000));
        cd.m.textContent = pad(Math.floor(diff % 3600000 / 60000));
        cd.s.textContent = pad(Math.floor(diff % 60000 / 1000));
      };
      tick();
      setInterval(tick, 1000);
    }

    /* ---------- Enquiry form: pre-select service from smart links ---------- */
    var serviceSelect = document.getElementById('mmc-service-select');
    if (serviceSelect) {
      document.querySelectorAll('[data-service]').forEach(function (el) {
        el.addEventListener('click', function () {
          var wanted = el.getAttribute('data-service');
          var match = Array.prototype.find.call(serviceSelect.options, function (o) {
            return o.value === wanted;
          });
          if (match) serviceSelect.value = wanted;
        });
      });
    }

    /* ---------- How it works: expanding card carousel ---------- */
    var track = document.querySelector('#process .howto-track');
    if (track) {
      var cards = Array.prototype.slice.call(track.querySelectorAll('.howto-card'));
      var active = 0;
      var setActive = function (i) {
        active = (i + cards.length) % cards.length;
        cards.forEach(function (card, n) {
          card.classList.toggle('is-active', n === active);
        });
      };
      cards.forEach(function (card, i) {
        card.addEventListener('click', function () { setActive(i); });
      });
      var prevBtn = document.querySelector('#process .howto-arrow[data-dir="prev"]');
      var nextBtn = document.querySelector('#process .howto-arrow[data-dir="next"]');
      if (prevBtn) prevBtn.addEventListener('click', function () { setActive(active - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { setActive(active + 1); });
    }
  });
})();
